// File: public/js/pages/moniteur.js
//
// The virtual monitor LANDING: create a session (mint a code) or join by code,
// then reveal the pairing hub (the code + the two role links + copy-link).

import { sendFetchRequest } from '/js/shared/utils/AjaxUtils.js';

(() => {
  'use strict';
  const wrap = document.querySelector('.mon-landing');
  if (!wrap) return;
  const displayBase = wrap.dataset.displayBase || '';
  const controlBase = wrap.dataset.controlBase || '';
  const joinBase = wrap.dataset.joinBase || '';

  const hub = document.getElementById('mon-hub');
  const codeEl = document.getElementById('mon-hub-code');
  const dispA = document.getElementById('mon-hub-display');
  const ctrlA = document.getElementById('mon-hub-control');
  const copyBtn = document.getElementById('mon-hub-copy');

  function showHub(code) {
    code = String(code || '').toUpperCase().trim();
    if (!code) return;
    codeEl.textContent = code;
    dispA.href = displayBase + '?s=' + encodeURIComponent(code);
    ctrlA.href = controlBase + '?s=' + encodeURIComponent(code);
    hub.hidden = false;
    hub.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  document.getElementById('mon-create').addEventListener('click', (e) => {
    const btn = e.currentTarget;
    btn.disabled = true;
    sendFetchRequest({
      payload: { name: 'monitorCreate' },
      onSuccess: (json) => { if (json.code) showHub(json.code); },
      onFinally: () => { btn.disabled = false; },
    });
  });

  document.getElementById('mon-join').addEventListener('submit', (e) => {
    e.preventDefault();
    const code = document.getElementById('mon-join-code').value;
    if (code && code.trim()) showHub(code);
  });

  copyBtn.addEventListener('click', () => {
    const url = joinBase + '?s=' + encodeURIComponent(codeEl.textContent);
    if (navigator.clipboard) {
      navigator.clipboard.writeText(url).then(() => { copyBtn.textContent = 'Lien copié ✓'; setTimeout(() => copyBtn.textContent = 'Copier le lien', 2000); });
    }
  });
})();
